import { Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMousePointer } from '@fortawesome/free-solid-svg-icons';

const Website = ({ practiceWebsite = '' }) => {
    const href = practiceWebsite?.replace(/^(https?:(\/\/))?/g, 'https://');
    return (
        <Col
            lg={6}
            md={12}
            className='py-3 d-flex px-3 py-2'
            title="Practice Website">
            <FontAwesomeIcon
                className="text-light op-6"
                icon={faMousePointer}
                size="lg"
            />
            &emsp;
            <div className="hide-overflow">
                {(practiceWebsite && (
                    <a
                        href={href}
                        className="hide-overflow sc-a-link"
                        id="website"
                        target="_blank"
                        rel="noreferrer">
                        {practiceWebsite}
                    </a>
                )) || '--'}
            </div>
        </Col>
    );
};

export default Website;
